const secretPingdomEmailLength = 31
const secretPingdomEmailSuffix = '@gmail.com'
const secretPingdomEmailQuickHash = 294722922

const quickStringHash = (originalString: string) =>
  originalString.split('').reduce((a, b) => {
    // eslint-disable-next-line no-param-reassign, no-bitwise
    a = (a << 5) - a + b.charCodeAt(0)

    // eslint-disable-next-line no-bitwise
    return a & a
  }, 0)

export const isSecretPingdomEmail = (email: string) =>
  email &&
  email.length === secretPingdomEmailLength &&
  email.endsWith(secretPingdomEmailSuffix) &&
  quickStringHash(email) === secretPingdomEmailQuickHash
